import React, { ReactNode, useMemo } from "react";
import styles from "./chip.module.css";
import { ChipIcon } from "./chip-icon.component";
import { Optional } from "../../types";

export type ChipProps = {
  children: ReactNode;
  variant?: "default" | "primary" | "secondary";
  as?: Optional<string>;
  dataQA?: string;
} & React.HTMLAttributes<HTMLDivElement>;

const variantMapping = {
  default: styles.Default,
  primary: styles.Primary,
  secondary: styles.Secondary,
};

export function Chip({
  children,
  as = "div",
  variant = "default",
  className = "",
  ...props
}: ChipProps) {
  const componentClassNames = useMemo(() => {
    const variantClassName = variantMapping[variant];

    return `${styles.Container} ${variantClassName} ${className}`;
  }, [variant]);

  return React.createElement(
    as ?? "div",
    {
      ...props,
      className: componentClassNames,
      "data-qa": props["dataQA"]
    },
    children
  );
}

export namespace Chip {
  export const Icon = ChipIcon;
}
